(function () {
  'use strict';

  /* ── Gallery ── */
  var slides = document.querySelectorAll('.g2-gallery__slide');
  var thumbs = document.querySelectorAll('.g2-gallery__thumb');

  function setSlide(idx) {
    slides.forEach(function (s) { s.classList.remove('active'); });
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    if (slides[idx]) slides[idx].classList.add('active');
    if (thumbs[idx]) thumbs[idx].classList.add('active');
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { setSlide(parseInt(this.dataset.idx)); });
    t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); } });
  });

  var gMain = document.getElementById('g2-gallery-main');
  if (gMain) {
    var startX = 0, curIdx = 0;
    gMain.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    gMain.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      curIdx = parseInt((document.querySelector('.g2-gallery__slide.active') || {dataset:{idx:0}}).dataset.idx || 0);
      var next = dx < 0 ? Math.min(curIdx + 1, slides.length - 1) : Math.max(curIdx - 1, 0);
      setSlide(next);
    }, { passive: true });
  }

  /* ── Qty selector + dynamic pricing ── */
  var qtyOpts   = document.querySelectorAll('.g2-qty__opt');
  var qtyInput  = document.getElementById('g2-qty-input');
  var priceCur  = document.querySelector('.g2-price__current');
  var priceWas  = document.querySelector('.g2-price__was');
  var pricePill = document.querySelector('.g2-price__pill');
  var atcBtn    = document.getElementById('g2-atc-btn');
  var stickyPrice = document.querySelector('.g2-sticky-atc__price > span:first-child');
  var stickyWas   = document.querySelector('.g2-sticky-atc__price .was');

  /* 1 acheté = 1 offert (Duo, qty 2) | 2 achetés = 2 offerts (Famille, qty 4) — toujours -50% */
  var BUNDLE_DISCOUNT = { 1: 0, 2: 0.50, 4: 0.50 };

  function parseMoney(str) {
    if (!str) return 0;
    var cleaned = str.replace(/[^0-9,.]/g, '');
    cleaned = cleaned.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    var val = parseFloat(cleaned);
    return isNaN(val) ? 0 : Math.round(val * 100);
  }

  var UNIT     = parseMoney(priceCur ? priceCur.textContent : '');
  var UNIT_WAS = parseMoney(priceWas ? priceWas.textContent : '');

  function fmtEUR(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00A0€';
  }

  function setAtcText(btn, txt) {
    if (!btn) return;
    var replaced = false;
    for (var i = btn.childNodes.length - 1; i >= 0; i--) {
      var n = btn.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim().length) { n.textContent = ' ' + txt; replaced = true; break; }
    }
    if (!replaced) btn.appendChild(document.createTextNode(' ' + txt));
  }

  function updatePricing(qty) {
    if (!UNIT) return;
    var d = BUNDLE_DISCOUNT[qty] || 0;
    var total = Math.round(UNIT * qty * (1 - d));
    var wasTotal = (UNIT_WAS ? UNIT_WAS : UNIT) * qty;
    var saved = wasTotal - total;

    if (priceCur)  priceCur.textContent = fmtEUR(total);
    if (priceWas && UNIT_WAS) priceWas.textContent = fmtEUR(wasTotal);
    if (pricePill) pricePill.textContent = 'Vous economisez ' + fmtEUR(saved > 0 ? saved : 0);
    setAtcText(atcBtn, 'Ajouter au panier — ' + fmtEUR(total));
    if (stickyPrice) stickyPrice.textContent = fmtEUR(total);
    if (stickyWas && UNIT_WAS) stickyWas.textContent = fmtEUR(wasTotal);
  }

  qtyOpts.forEach(function (opt) {
    opt.addEventListener('click', function () {
      qtyOpts.forEach(function (o) { o.classList.remove('selected'); });
      this.classList.add('selected');
      var q = parseInt(this.dataset.qty) || 1;
      if (qtyInput) qtyInput.value = q;
      updatePricing(q);
    });
    opt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); } });
  });

  var initSel = document.querySelector('.g2-qty__opt.selected');
  updatePricing(initSel ? (parseInt(initSel.dataset.qty) || 1) : 1);

  /* ── Accordions ── */
  document.querySelectorAll('.g2-accord__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var accord = this.closest('.g2-accord');
      var isOpen = accord.classList.contains('open');
      document.querySelectorAll('.g2-accord').forEach(function (a) {
        a.classList.remove('open');
        a.querySelector('.g2-accord__btn').setAttribute('aria-expanded', 'false');
        a.querySelector('.g2-accord__body').style.maxHeight = null;
      });
      if (!isOpen) {
        accord.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
        var body = accord.querySelector('.g2-accord__body');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ── FAQ ── */
  document.querySelectorAll('.g2-faq-item__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.g2-faq-item');
      var isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      this.setAttribute('aria-expanded', !isOpen);
      var body = item.querySelector('.g2-faq-item__body');
      body.style.maxHeight = isOpen ? null : body.scrollHeight + 'px';
    });
  });

  /* ── Before/After slider ── */
  var slider = document.getElementById('g2-slider');
  var sliderAfter = document.getElementById('g2-slider-after');
  var sliderLine = document.getElementById('g2-slider-line');
  var sliderHandle = document.getElementById('g2-slider-handle');

  if (slider && sliderAfter) {
    var isDragging = false;

    function setPos(pct) {
      pct = Math.max(5, Math.min(95, pct));
      sliderAfter.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      sliderLine.style.left = pct + '%';
      sliderHandle.style.left = pct + '%';
      var lBefore = document.getElementById('g2-label-before');
      var lAfter = document.getElementById('g2-label-after');
      if (lBefore) lBefore.style.right = 'calc(' + (100 - pct) + '% + 16px)';
      if (lAfter) lAfter.style.left = 'calc(' + pct + '% + 16px)';
    }

    function getPercent(clientX) {
      var rect = slider.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    slider.addEventListener('mousedown', function (e) { isDragging = true; setPos(getPercent(e.clientX)); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { if (isDragging) setPos(getPercent(e.clientX)); });
    window.addEventListener('mouseup', function () { isDragging = false; });
    slider.addEventListener('touchstart', function (e) { isDragging = true; setPos(getPercent(e.touches[0].clientX)); }, { passive: true });
    window.addEventListener('touchmove', function (e) { if (isDragging) setPos(getPercent(e.touches[0].clientX)); }, { passive: true });
    window.addEventListener('touchend', function () { isDragging = false; });
  }

  /* ── Sticky ATC ── */
  var stickyAtc = document.getElementById('g2-sticky-atc');
  var heroSection = document.getElementById('g2-hero');
  if (stickyAtc && heroSection) {
    var observer = new IntersectionObserver(function (entries) {
      stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0.1 });
    observer.observe(heroSection);
  }

  /* ── Scroll reveal ── */
  var reveals = document.querySelectorAll('.g2-reveal');
  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); revealObs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { revealObs.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

})();
